import { render, staticRenderFns } from "./newComManagementCoupon.vue?vue&type=template&id=8875f64a&scoped=true"
import script from "./newComManagementCoupon.vue?vue&type=script&lang=js"
export * from "./newComManagementCoupon.vue?vue&type=script&lang=js"
import style0 from "./newComManagementCoupon.vue?vue&type=style&index=0&id=8875f64a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8875f64a",
  null
  
)

export default component.exports